export default __webpack_public_path__ + "static/media/1.b0ee48b0.png";